module.exports = __webpack_public_path__ + "static/media/ddling.6f819a8c.mp3";